import { render, staticRenderFns } from "./questInvitation.vue?vue&type=template&id=6b147b4f"
import script from "./questInvitation.vue?vue&type=script&lang=js"
export * from "./questInvitation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports